import { AppQueryParams, QueryParams } from '@/App'
import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

const useQuery = () => {
  const [urlSearchParams, setSearchParams] = useSearchParams()
  // const [queryParams, setQueryParams] = useState<{ [key: string]: string | undefined }>(() => {
  //   const queryParamsObject: { [key: string]: string | undefined } = {}
  //   Object.values(QueryParams).forEach((param) => {
  //     queryParamsObject[param] = urlSearchParams.get(param) ?? undefined
  //   })
  //   return queryParamsObject
  // })

  const queryParams: AppQueryParams = useMemo(() => {
    const appQueryParams = {} as AppQueryParams
    urlSearchParams.forEach((value, key) => {
      appQueryParams[key as QueryParams] = value
    })
    return appQueryParams
  }, [urlSearchParams])

  // useEffect(() => {
  //   const queryParamsObject: { [key: string]: string | undefined } = {}
  //   Object.values(QueryParams).forEach((param) => {
  //     queryParamsObject[param] = urlSearchParams.get(param) ?? undefined
  //   })
  //   setQueryParams(queryParamsObject)
  // }, [urlSearchParams])

  const setURLQueryParams = (params: { [key in QueryParams]?: string | undefined }) => {
    const newUrlSearchParams = new URLSearchParams(urlSearchParams)
    Object.entries(params).forEach(([key, value]) => {
      newUrlSearchParams.set(key, value)
    })
    setSearchParams(newUrlSearchParams)
  }

  return { queryParams, setURLQueryParams }
}

export default useQuery
